import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function UnitCostMoqShortFall() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedDisplayColumn } = planningBottomup;
  const UnitCostMoqShortFallFields = [
    {
      keyName: 'unitMOQShortfall',
      name: 'Unit MOQ Shortfall',
    },
    // {
    //   keyName: "costMOQShortfall",
    //   name: "Cost MOQ Shortfall",
    // },
  ];
  const isTableVisible = UnitCostMoqShortFallFields.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));
  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {UnitCostMoqShortFallFields?.map((UnitCostMoqItem, i) => {
              const isVisible = checkVisibleBottomUp(UnitCostMoqItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{UnitCostMoqItem?.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {UnitCostMoqShortFallFields?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <td key={iTD} className="text-right">
                        {trItem[tdItem?.keyName]}
                      </td>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default UnitCostMoqShortFall;
